import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Pagination } from "react-bootstrap";
import DateRange3 from "../../Component/DateRange/DateRange3";
import { left, right } from "../../assets/img";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import useStoreKv from "../redux/store/useStorekv";
import { useAppContext } from "../../Services/AppContext";
import CustomScroll from "../../Component/CustomScroll";

const OverallResult = () => {
  const navigate = useNavigate();
  const { kv, set } = useStoreKv();
  const Results = kv.results || [];
  const [loading, setLoading] = useState(false);
  const [drawDate, setDrawDate] = useState('');
  const [results, setResults] = useState(Results);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const { arrowEnable } = useAppContext();

  // FETCH DATA FROM API
  const getList = async () => {
    try {
      setLoading(true);
      const res = await get(`${URLS.OVERALLRESULT}?date=${drawDate}&page=${currentPage}`);

      if (res?.status === "success" && Array.isArray(res.data)) {
        setResults(res.data);
        set('results', res?.data);
        setPagination(res.pagination);
//         console.log("pagination data", res?.pagination);
      } else {
        setResults([]);
        setPagination({});
      }
    } catch (error) {
//       console.log("Error fetching results:", error);
      setResults([]);
      setPagination({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, [drawDate, currentPage]);

  useEffect(() => {
  }, [arrowEnable]);

  return (
    <div className="dashRightView marginScrolls">
      <CustomScroll >
        <div style={{ paddingBottom: 200, paddingTop: 0 }} className="container_overalls col-md-5">
          {/* DATE PICKER */}
          <div className="my-4 col-md-5">
            <DateRange3 selectedDate={drawDate} setSelectedDate={setDrawDate} />
          </div>
          {results.length === 0 && !loading && (
            <p style={{ textAlign: "center" }} className="f3 fs-sm-14 fs-md-16 fs-lg-18 gray mt-4">
              No results found.
            </p>
          )}

          {/* DISPLAY RESULTS */}
          {results.map((res, idx) => (
            <div className="mt-3 col-md-5" key={idx}>

              {/* EDIT BUTTON — only when API returns edit: true */}
              <div className="d-flex ac-je mb-2">
                {res.edit === true && (
                  <button
                    onClick={() => navigate("/announce-result-edit", { state: { editData: res } })}
                    className="f3 fs-sm-8 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15 edit1-btn"
                  >
                    Edit
                  </button>
                )}
              </div>

              {/* RESULT CARD */}
              <div
                style={{ backgroundColor: "#F0EDE6", borderRadius: 20 }}
                className="check_result border shadow-sm"
              >
                {/* DATE */}
                <div className="d-flex ac-jb my-2">
                  <h4 className="f3 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16 ">
                    Date
                  </h4>
                  <p className="f2 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16 gray">{res.date}</p>
                </div>

                {/* LOT NAME */}
                <div className="d-flex ac-jb my-2">
                  <p className="f3 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16 ">
                    Lot Name
                  </p>
                  <p className="f2 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16 gray">{res.lot_name}</p>
                </div>

                {/* TIME */}
                <div className="d-flex ac-jb my-2">
                  <p className="f3 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16 ">
                    Time
                  </p>
                  <p className="f2 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16 gray">{res.time}</p>
                </div>

                {/* WINNING NUMBER BOXES */}
                <div className="d-flex ac-jb my-2">
                  <p className="f3 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16 ">
                    Result Number
                  </p>

                  <div className="d-flex gap-2">
                    {String(res.winning_number)
                      .split("")
                      .map((num, i) => (
                        <input
                          key={i}
                          maxLength={1}
                          type="text"
                          className="result-input f2 text-center fs-xs-16 fs-sm-12 fs-md-14 fs-lg-14 fs-xl-15 fs-xxl-20 placholdercolorchanges2"
                          readOnly
                          value={num}
                          style={{
                            width: 28,
                            height: 28,
                            textAlign: "center",
                            borderRadius: 30,
                          }}
                        />
                      ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CustomScroll>
      {/* PAGINATION */}
      <Row style={{ width: !arrowEnable ? '100%' : '' }} className="justify-content-between table-show  bg-primary2 mt-4">
        <Col className="d-flex ac-jb pagination_boxs align-items-center">

          <p className="px-1 mb-0 f3 fs-xs-13 fs-md-14">
            Total Pages: <strong>{pagination?.total_pages || 1}</strong>
          </p>

          <Pagination className="gap-1 pointer mb-0 d-flex align-items-center">
            {currentPage > 1 && (
              <img
                src={left}
                width={18}
                alt="Previous"
                onClick={() => setCurrentPage(currentPage - 1)}
                style={{
                  opacity: currentPage === 1 ? 0.4 : 1,
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                }}
              />)}

            <input
              type="number"
              value={currentPage}
              onFocus={(e) => e.target.select()} // Select full value on click
              onKeyDown={(e) => {
                // Clear value completely on first Backspace
                if (e.key === "Backspace") {
                  setCurrentPage("");
                }
              }}
              onChange={(e) => {
                const val = e.target.value;

                // Allow empty while typing
                if (val === "") {
                  setCurrentPage("");
                  return;
                }

                const num = Number(val);
                const max = pagination?.total_pages || 1;

                if (num >= 1 && num <= max) {
                  setCurrentPage(num);
                }
              }}
              onBlur={() => {
                // Reset to 1 if empty or invalid
                if (!currentPage || currentPage < 1) {
                  setCurrentPage(1);
                }
              }}
              style={{
                width: 25,
                height: 25,
                borderRadius: 8,
                position: "relative",
                paddingBottom: 2,
                fontSize: 12,
                border: "2px solid #006d68",
                textAlign: "center",
              }}
              className="placholdercolorchanges2"
            />


            {/* Next */}
            {currentPage < (pagination.total_pages || 1) && (
              <img
                src={right}
                width={18}
                alt="Next"
                onClick={() => setCurrentPage(currentPage + 1)}
                style={{
                  opacity: currentPage === (pagination.total_pages || 1) ? 0.4 : 1,
                  cursor: currentPage === (pagination.total_pages || 1) ? "not-allowed" : "pointer",
                }}
              />)}
          </Pagination>
        </Col>
      </Row>
    </div>
  );
};

export default OverallResult;
